import { fetchWithAuth } from './fetchWithAuth'

export async function createConfig(
  token: string,
  body: Record<string, unknown>,
): Promise<void> {
  const { inventorySystemProfileCode, ...rest } = body
  const payload = {
    ...rest,
    ...(inventorySystemProfileCode !== undefined
      ? { inventorySystemCode: inventorySystemProfileCode }
      : {}),
  }

  await fetchWithAuth('/v1/tenant-configs', token, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}
